// @ts-ignore
import { loadStripe, Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null>

// Get Stripe configuration from backend
export const getStripeConfig = async () => {
  const API_BASE_URL = process.env.NODE_ENV === 'production' 
    ? 'https://bmwfinder-api-25f5f05731c4.herokuapp.com' 
    : 'http://localhost:8083'

  const response = await fetch(`${API_BASE_URL}/api/stripe/config`)
  if (!response.ok) {
    throw new Error('Failed to fetch Stripe configuration')
  }
  return response.json()
}

// Initialize Stripe
export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = getStripeConfig().then(config => 
      loadStripe(config.publishable_key)
    )
  }
  return stripePromise
}

// Create checkout session
export const createCheckoutSession = async (
  token: string,
  tier: 'basic' | 'premium' | 'instant' | 'day_trial' | 'basic_exit' | 'premium_exit' | 'instant_exit' = 'premium',
  billingInterval: 'month' | 'year' = 'month'
) => {
  const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? 'https://bmwfinder-api-25f5f05731c4.herokuapp.com'
    : 'http://localhost:8083'

  const body = { tier, billing_interval: billingInterval }

  const response = await fetch(`${API_BASE_URL}/api/stripe/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.message || 'Failed to create checkout session')
  }

  return response.json()
}

// Sync subscription from Stripe (useful when webhooks don't work)
export const syncSubscription = async (token: string) => {
  const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? 'https://bmwfinder-api-25f5f05731c4.herokuapp.com'
    : 'http://localhost:8083'

  const response = await fetch(`${API_BASE_URL}/api/stripe/sync-subscription`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.message || 'Failed to sync subscription')
  }

  return response.json()
}
